import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Login from '@/components/Login'
import Logout from '@/components/Logout'
import List from '@/components/List'
import Send from '@/components/Send'
import Stats from '@/components/Stats'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/ui',
      name: 'Home',
      component: Home
    },
    {
      path: '/ui/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/ui/logout',
      name: 'Logout',
      component: Logout
    },
    {
      path: '/ui/list',
      name: 'List',
      component: List,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/ui/stats',
      name: 'Stats',
      component: Stats,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/ui/send',
      name: 'Send',
      component: Send,
      meta: {
        requiresAuth: true
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (sessionStorage.getItem('token') == null) {
      next({
        path: '/ui/login'
      })
    }
  }

  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js